<div [class.hidden]="!show">
    <div id="overlay">
        <div *ngIf="show">
            <img class="loding-img" src="assets/img/loder.svg"> </div>
    </div>
</div>